/* eslint-disable @typescript-eslint/no-unused-vars */
import { message } from 'antd';
import React from 'react';
import { useMutation } from 'react-query';
import { useNavigate, useSearchParams } from 'react-router-dom';

import Loading from 'components/atoms/Loading';
import useDidMount from 'hooks/useDidMount';
import { loginGoogleService } from 'services/auth';
import { getLocalStorage, setAccessToken, setRefreshToken } from 'services/common/storage';
import { getProfileAction } from 'store/auth';
import { useAppDispatch } from 'store/hooks';
import { LOCAL_STORAGE, ROUTE_PATHS } from 'utils/constants';

const LoginGoogle: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const code = searchParams.get('code');
  const state = searchParams.get('state');

  const { mutate: handleLoginSocial, isLoading } = useMutation(
    ['loginSocialMutate'],
    loginGoogleService,
    {
      onSuccess(data) {
        const { accessToken, refreshToken } = data;
        const curentToken = getLocalStorage(LOCAL_STORAGE.ACCESS_TOKEN);
        if (!curentToken) {
          setAccessToken(accessToken);
          setRefreshToken(refreshToken);
        }

        dispatch(getProfileAction()).unwrap().then((res) => {
          if (res) {
            localStorage.removeItem(LOCAL_STORAGE.SOCIAL_PKCE_STATE);
            localStorage.removeItem(LOCAL_STORAGE.SOCIAL_PKCE_UUID);
            localStorage.removeItem(LOCAL_STORAGE.SOCIAL_CODE_CHALLENGE);

            const socialLoginType = getLocalStorage('SOCIAL_LOGIN_TYPE');
            if (socialLoginType === 'googleDrive') {
              sessionStorage.setItem('OPEN_KNOWLEDGE_MODAL', 'googleDrive');
              sessionStorage.setItem('AUTO_SELECT_GOOGLE_DRIVE', 'true');
              localStorage.removeItem('SOCIAL_LOGIN_TYPE');
            }

            const redirectPath = getLocalStorage(LOCAL_STORAGE.REDIRECT_PATH);
            if (redirectPath) {
              localStorage.removeItem(LOCAL_STORAGE.REDIRECT_PATH);
              navigate(redirectPath);
            } else {
              navigate(ROUTE_PATHS.AGENT);
            }
          }
        });
      },
      onError() {
        navigate(ROUTE_PATHS.LOGIN);
        message.error('Login fail! Please double check.');
      }
    }
  );

  useDidMount(() => {
    if (code) {
      const stateLocal = getLocalStorage(LOCAL_STORAGE.SOCIAL_PKCE_STATE);
      const uuid = getLocalStorage(LOCAL_STORAGE.SOCIAL_PKCE_UUID);
      const codeChallenge = getLocalStorage(LOCAL_STORAGE.SOCIAL_CODE_CHALLENGE);
      if (stateLocal === state && uuid) {
        handleLoginSocial({
          platform: 'web',
          redirectUri: `${window.location.origin}${ROUTE_PATHS.LOGIN_GOOGLE}`,
          code,
          codeVerifier: codeChallenge || '',
          uuid
        });
      }
    }
  });

  return (
    <div className="p-loginGoogle">
      {isLoading && <Loading width={50} variant="fullscreen" />}
    </div>
  );
};

export default LoginGoogle;
